module.exports = __webpack_public_path__ + "img/57.4dbcc9f8.png";